
<!-- <h5 style="background-color:greenyellow">before - main</h5> -->
<main style="border:none 1px gray; width: 98vw; margin-left: 0vw;">
    <!-- <h5 style="background-color:greenyellow">inside, before router-outlet - main</h5> -->
    <!-- router-outlet-debug style="border:dotted 1px pink"></router-outlet-debug> -->
    <router-outlet></router-outlet>
    <!-- <h5 style="background-color:greenyellow">inside, after router-outlet - main</h5> -->
</main>
<!-- <h5 style="background-color:greenyellow">after - main</h5> -->


